<!--
@author: 赵静静
@time: 2021/10/21
@desc: 登录页面
-->
<template>
  <div class="login">
    <div class="loginForm">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="扫码登录" name="first">
          <div class="vue-qr">
            <vue-qr :text="qrCodeText" :size="300"></vue-qr>
            <div class="obscuration" v-if="qrCodeStatus == 4">
              <div class="codeInvalid">二维码已失效</div>
              <img src="../../assets/img/login/btn_refresh.png" @click="btn_refresh">
            </div>
            <img src="../../assets/img/login/refresh.png" class="refresh" @click="btn_refresh">
          </div>
        </el-tab-pane>
        <el-tab-pane label="验证码登录" name="second">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" v-if="hasOrg !== 1">
            <el-form-item prop="phone">
              <span class="title">手机号</span>
              <el-input
                v-model="loginForm.phone"
                clearable
                autoComplete="off"
                size="large"
                placeholder="请输入手机号码">
                <div slot="prefix" class="style17 shouJi"></div>
              </el-input>
            </el-form-item>
            <div class="codeStyle">
              <el-form-item prop="checkCode" style="margin-bottom: 20px">
                <span class="title">验证码</span>
                <el-input
                  v-model="loginForm.checkCode"
                  size="large"
                  clearable
                  autoComplete="off"
                  placeholder="请输入短信验证码">
                  <template slot="append" class="appendCode">
          <span
            @click="handleSend"
            class="msg-text"
            :class="[{ display: msgKey }]"
          >{{ msgText }}</span
          >
                  </template>
                </el-input>
              </el-form-item>
              <el-checkbox v-model="checked">同意邀工网<span class="agreementDocument"
                                                        @click="goToAgreement('serviceAgreement')">《用户服务协议》</span><span
                class="agreementDocument" @click="goToAgreement('userAgreement')">《隐私协议》</span></el-checkbox>
              <el-button type="primary" class="login-submit" @click.native.prevent="handleLogin">登录</el-button>
            </div>
          </el-form>
          <div v-else class="companyListStyle">
            <img src="../../assets/img/login/btn_back.png" class="btn_back" @click="btn_back">
            <div class="companyText">请选择身份登录</div>
            <div class="companyList">
              <div v-for="(item, index) in list" :key="index" class="companyName" :class="{active:index === isActive}"
                   @click="chosenCompany(index, item.name, item.id, item.currentRole)">
                <span class="nameText">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="text">客服电话：0512-66836609&nbsp;&nbsp;&nbsp;&nbsp;工作时间：工作日 9:30-18:30</div>
    </div>
  </div>
</template>

<script>
import { sendLoginCode, pcLogin, scanLogin, isExpire, getMyCompany, loginRecord, recordLoginCompany } from '@api/login'
import vueQr from 'vue-qr'

const MSGINIT = '发送验证码'
/* eslint-disable */
const MSGSCUCCESS = '${time}秒后重发'
const MSGTIME = 60
export default {
  name: 'index',
  components: {
    vueQr
  },
  data () {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      } else if (!/^\d{11}$/.test(value)) {
        return callback(new Error('请输入有效的手机号'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      hasOrg: '',
      activeName: 'first',
      msgText: MSGINIT,
      msgTime: MSGTIME,
      msgKey: false,
      checked: false,
      isSendCode: false,
      time: null,
      timer: null,
      qrCodeText: '',
      auth: '',
      qrCodeStatus: '',
      loginForm: {},
      loginRules: {
        phone: [{ required: true, validator: validatePhone, trigger: ['blur'] }],
        checkCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      list: [],
      isActive: ''
    }
  },
  created () {
    this.getQrCode()
  },
  mounted () {
    this.getIsExpire()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    // 手机号登录发送验证码
    handleSend () {
      if (this.loginForm.phone) {
        sendLoginCode({
          phone: this.loginForm.phone
        }).then(res => {
          if (res.data.code === 200) {
            this.$message.success('验证码发送成功')
            this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
            this.time = setInterval(() => {
              this.msgTime--
              this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
              if (this.msgTime === 0) {
                this.msgTime = MSGTIME
                this.msgText = MSGINIT
                clearInterval(this.time)
              }
            }, 1000)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请先填写手机号')
      }
    },
    // 点击登录
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (this.checked === false) {
            this.$message.error('请先阅读并同意用户服务协议以及隐私协议!')
            return false
          }
          this.loading = true
          pcLogin({
            checkCode: this.loginForm.checkCode,
            phone: this.loginForm.phone
          }).then(res => {
            if (res.data.code === 200) {
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('hasOrg', res.data.data.hasOrg)// 当前账号是否有其他组织
              localStorage.setItem('isAuth', res.data.data.isAuth) // 是否认证
              localStorage.setItem('currentRole', res.data.data.currentRole) // 是否认证
              if (res.data.data.hasOrg === 1) {
                this.hasOrg = 1
                this.getMyCompany()
              } else {
                localStorage.setItem('companyId', res.data.data.currentCompanyId)
                localStorage.setItem('loginName', res.data.data.name)
                localStorage.setItem('currentRole', res.data.data.currentRole)
                this.loginRecord(false)
                this.$router.replace('/getJob')
              }
              this.loading = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },

    btn_back () {
      this.hasOrg = 0
      this.loginForm = {
        checkCode: '',
        phone: ''
      }
      this.msgText = '发送验证码'
      this.msgTime = 60
      clearInterval(this.time)
    },

    // 记录登录日志
    loginRecord (hasOrg) {
      let brand = ''
      let model = ''
      let Sys = {}
      let ua = navigator.userAgent.toLowerCase()
      let s;
      (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
        (s = ua.match(/msie ([\d\.]+)/)) ? Sys.ie = s[1] :
          (s = ua.match(/edge\/([\d\.]+)/)) ? Sys.edge = s[1] :
            (s = ua.match(/firefox\/([\d\.]+)/)) ? Sys.firefox = s[1] :
              (s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? Sys.opera = s[1] :
                (s = ua.match(/chrome\/([\d\.]+)/)) ? Sys.chrome = s[1] :
                  (s = ua.match(/version\/([\d\.]+).*safari/)) ? Sys.safari = s[1] : 0
      // 根据关系进行判断
      if (Sys.ie) {
        brand = 'IE'
        model = Sys.ie
      } else if (Sys.edge) {
        brand = 'EDGE'
        model = Sys.edge
      } else if (Sys.firefox) {
        brand = 'Firefox'
        model = Sys.firefox
      } else if (Sys.chrome) {
        brand = 'Chrome'
        model = Sys.chrome
      } else if (Sys.opera) {
        brand = 'Opera'
        model = Sys.opera
      } else if (Sys.safari) {
        brand = 'Safari'
        model = Sys.safari
      }

      // 记录登录日志
      loginRecord({
        clientType: 2,
        brand: brand,
        model: model
      }).then(res => {
      })

      if (hasOrg) {
        // 记录当前身份
        recordLoginCompany().then(res => {
        })
      }
    },

    chosenCompany (index, name, id, currentRole) {
      if (this.isActive === index) {
        this.isActive = ''
      } else {
        this.isActive = index
        localStorage.setItem('companyId', id)
        localStorage.setItem('loginName', name)
        localStorage.setItem('currentRole', currentRole)
      }

      this.loginRecord(true)

      this.$router.replace('/getJob')
    },
    getMyCompany () {
      getMyCompany().then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取二维码地址
    getQrCode () {
      scanLogin().then(res => {
        if (res.data.code === 200) {
          this.auth = res.data.data.auth
          this.qrCodeText = res.data.data.url
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 轮询查询扫描状态
    getIsExpire () {
      this.timer = setInterval(() => {
        isExpire({
          auth: this.auth
        }).then(res => {
          if (res.data.code === 200) {
            // 二维码状态（0-未扫描，1-已扫描未确认，2-已扫描已取消，3-已扫描已登录，4-二维码失效）
            this.qrCodeStatus = res.data.data.status
            if (res.data.data.status === 3) {
              localStorage.setItem('companyId', res.data.data.currentCompanyId)
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('loginName', res.data.data.name)
              localStorage.setItem('isAuth', res.data.data.isAuth) // 是否认证
              localStorage.setItem('hasOrg', res.data.data.hasOrg)// 当前账号是否有其他组织
              localStorage.setItem('currentRole', res.data.data.currentRole)// 当前的角色
              this.$router.replace('/getJob')
            }
            if (res.data.data.status === 4) {
              clearInterval(this.timer)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }, 1000)
    },
    handleClick (tab) {
      if (tab.name === 'first') {
        // 重新获取二维码
        this.getQrCode()
        this.getIsExpire()
        this.msgText = '发送验证码'
        this.msgTime = 60
        clearInterval(this.time)
      } else if (tab.name === 'second') {
        this.loginForm = {
          checkCode: '',
          phone: ''
        }
        clearInterval(this.timer)
        this.checked = false
      }
    },
    btn_refresh () {
      this.getQrCode()
      this.getIsExpire()
    },
    // 去隐私协议页面
    goToAgreement (name) {
      const route = this.$router.resolve({ name: name })
      window.open(route.href, '_blank')
    },
  }
}
</script>

<style lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../../assets/img/login/bg_login.png");
  background-size: cover;

  .loginForm {
    width: 980px;
    height: 560px;
    background-image: url("../../assets/img/login/bg.png");
    background-size: cover;
    position: relative;

    .text {
      position: absolute;
      bottom: 14px;
      right: 64px;
      color: #333333;
      line-height: 21px;
      font-size: 16px;
    }

    .title {
      color: #333333;
      line-height: 21px;
      font-size: 16px;
    }

    .login-form {
      width: 80%;
      margin-left: 4%;
    }

    .el-input-group__append {
      background-color: #0368C1;
      color: #fff;
      cursor: pointer;
    }

    .agreementDocument {
      color: #0368C1;

      &:hover {
        text-decoration: underline;
      }
    }

    .login-submit {
      display: block;
      margin: 16% auto 0;
      width: 150px;
      height: 40px;
      background: #0368C1;
      border-radius: 2px;
      font-size: 16px;
    }

    .vue-qr {
      width: 300px;
      margin: 0 auto;
      position: relative;
    }

    .refresh {
      width: 88px;
      position: absolute;
      left: 38%;
      bottom: -22px;

      &:hover {
        cursor: pointer;
      }
    }

    .obscuration {
      width: 300px;
      height: 300px;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(51, 51, 51, 0.7);

      .codeInvalid {
        text-align: center;
        margin: 100px auto 30px;
        color: #FFFFFF;
        font-size: 20px;
      }

      img {
        width: 124px;
        position: absolute;
        top: 60%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
    }
  }

  .el-tabs {
    position: absolute;
    top: 50px;
    right: 80px;

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__item.is-active {
      color: #0368C1;
      font-weight: bold;
    }

    .el-tabs__active-bar {
      height: 4px;
      background-color: #0368C1;
    }

    .el-tabs__item {
      color: #333333;
      line-height: 33px;
      font-size: 24px;
      padding: 0 70px;
    }

    .el-tabs__header {
      margin: 0 0 10px;
    }

    .el-tab-pane {
      padding-bottom: 20px;
    }
  }

  .companyListStyle {
    width: 80%;
    margin: 0 auto;

    .companyList {
      max-height: 18vh;
      overflow-y: scroll;
    }

    .companyText {
      color: #333333;
      font-size: 24px;
      text-align: center;
      margin-bottom: 36px;
    }

    .btn_back {
      width: 60px;
      margin-bottom: 20px;
    }
  }

  .companyName {
    line-height: 40px;
    font-size: 20px;
    color: #333;
    text-align: center;
    margin-bottom: 16px;
    background: #E9E9E9;
    cursor: pointer;
  }

  .active {
    background: #0368C1;
    color: #fff;
  }

  ::-webkit-scrollbar {
    width: 2px;
    height: 1px;
  }

  ::-webkit-scrollbar-thumb { //滑块部分
    border-radius: 5px;
    background-color: #eee;
  }

  ::-webkit-scrollbar-track { //轨道部分
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 5px;

  }
}
</style>
